export default __webpack_public_path__ + "static/media/fair_dist.35d753f5.png";